import { uniqBy } from 'lodash';
import * as React from 'react';

import { isSet } from '@utils';
import { DomainId } from '@models/feature-descriptor-domain';

import { DescriptionsTree } from '../models';

export const DomainsDescriptionsTreeItemSelectionContext = React.createContext<
  | undefined
  | [
      Record<DescriptionsTree.NodeId, DomainId[]>,
      {
        toggleTreeItemSelection: (
          nodeId: DescriptionsTree.NodeId,
          domains: DomainId[]
        ) => void;
      }
    ]
>(undefined);

export function useDomainsDescriptionsTreeItemSelection() {
  const context = React.useContext(DomainsDescriptionsTreeItemSelectionContext);
  if (context === undefined) {
    throw new Error(
      'useDomainsDescriptionsTreeItemSelection must be used within a DomainsDescriptionsTreeItemSelectionContext'
    );
  }
  return context;
}

export function DomainsDescriptionsTreeItemSelectionContextProvider(
  props: React.PropsWithChildren<Record<never, any>>
) {
  const [selectedTreeItems, setSelectedTreeItems] = React.useState<
    Record<DescriptionsTree.NodeId, DomainId[]>
  >(() => ({}));

  function toggleTreeItemSelection(
    nodeId: DescriptionsTree.NodeId,
    domains: DomainId[]
  ) {
    if (isSet(selectedTreeItems[nodeId])) {
      const { [nodeId]: _remove, ...rest } = selectedTreeItems;
      setSelectedTreeItems(rest);
    } else {
      setSelectedTreeItems({
        ...selectedTreeItems,
        [nodeId]: uniqBy(domains, JSON.stringify),
      });
    }
  }

  return (
    <DomainsDescriptionsTreeItemSelectionContext.Provider
      value={[selectedTreeItems, { toggleTreeItemSelection }]}
      {...props}
    />
  );
}
